// GCK-20989: as telas globais do core (usuarios, lojas, planos, carteira, ajuda...) sao
// replicadas em cada modulo via `formataRotasGlobais('<modulo>', rotas)`, que prefixa
// `path`/`alias`. Duas consequencias para este arquivo:
//   1. o wrapper nao pode ter `path: '/'` — prefixado viraria `/<modulo>/` e sombrearia o
//      wrapper do proprio modulo;
//   2. nao pode ter `name` — a copia prefixada nasce com o mesmo nome e o vue-router
//      reclama de rota nomeada duplicada.
const routes = [
    {
        path: '/backup_dados',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                path: '/backup_dados',
                alias: '/backup_dados/index',
                component: () => import('../views/Listar')
            },
            {
                path: '/backup_dados/baixar/:id',
                component: () => import('../views/Listar')
            }
        ]
    }
]

export default routes
